/**
 * Lock reasons reported by the API (`src/helper/story-access.helper.ts`).
 *
 * The home feed now withholds story content server-side instead of relying on
 * the page to guard the click, so a locked card arrives with `is_locked: true`
 * and one of these reasons. The existing local checks (`idValidAccount` +
 * `isSunday`, `isWeeklyReadingBlocked`) still run: they decide what the page
 * renders before any fetch resolves, and they keep working against an older
 * backend that sends neither field.
 */
export const STORY_LOCK_FREE_SUNDAY_ONLY = 'free_sunday_only'
export const STORY_LOCK_WEEKLY_OFFER = 'weekly_offer'
